module.exports = __webpack_public_path__ + "app/components/support/support.view.html";